module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_250000_500000.ac5860b6.png";